import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'antd'

const ItemDetail = ({ item }) => {
  const [options, setOptions] = useState([])

  useEffect(() => {
    if (item) {
      let options = []

      Object.keys(item.options).forEach(key => {
        options = [...options, { key, value: item.options[key] }]
      })

      setOptions(options)
    }
  }, [item])

  const _renderOption = ({ key, value }) => (
    <Row key={key}>
      <Col span={12}>{key}</Col>
      <Col span={12}>{value}</Col>
    </Row>
  )

  const _renderAdditionalDetail = () => (
    <Row>
      <Col span={12}>Cost</Col>
      <Col span={12}>{item.cost}</Col>
      <Col span={12}>Quantity</Col>
      <Col span={12}>{item.quantity}</Col>
      { !!item.comment && (
        <>
          <Col span={12}>Comment</Col>
          <Col span={12}>{item.comment}</Col>
        </>
      )}
    </Row>
  )

  return (
    <Row gutter={16}>
      <Col span={12}>
        {options.map(_renderOption)}
      </Col>
      <Col span={12}>
        {_renderAdditionalDetail()}
      </Col>
    </Row>
  )
}

ItemDetail.propTypes = {
  item: PropTypes.object,
  key: PropTypes.string,
  value: PropTypes.string
}

export default ItemDetail
